export default defineNuxtRouteMiddleware(async (to, from) => {
    const userStore = useUserStore()

    if (!userStore.isInitialized) {
        try {
            await userStore.getUserData()
        } catch (e) {
            console.error('Ошибка при получении данных пользователя:', e)
        }
    }

    const privateRoutes = ['/profile', '/menu']

    const isPrivateRoute = privateRoutes.some(route => to.path.startsWith(route))

    if (isPrivateRoute && !userStore.isAuth) {
        return navigateTo({
            path: '/',
            query: {
                ...to.query,
                redirect: to.path
            }
        })
    }

    if (userStore.isAuth && to.path === '/') {
        const redirectToPath = to.query.redirect as string

        if (redirectToPath) {
            const targetQuery = { ...to.query }
            delete targetQuery.redirect

            return navigateTo({
                path: redirectToPath,
                query: targetQuery
            })
        }
        return navigateTo({
            path: '/profile',
            query: from.query
        })
    }

    if(isPrivateRoute && to.path.startsWith('/profile/') && to.params.mode) {
        const isValidMode = ['edit', 'view', 'analytics'].includes(to.params.mode as string)
        if (!isValidMode) {
            return navigateTo('/404')
        }
    }
})
